import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import arrow from "../../../../static/arrow-triangle-down.svg";
import { ReactComponent as Balance } from "../../../../static/mutual-wallet-balance.svg";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import { withTranslation, Trans } from "react-i18next";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import Grow from "@material-ui/core/Grow";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { New_Travel_PaymentMethod } from "../../../../Redux/actions/actionNames";
import { ReactComponent as Plus } from "../../../../static/plus1.svg";
import { get_customerPannel_type, get_Id, get_lang, Get_Permisssion } from "../../../../helper/UserData/userdate";
import { ReactComponent as SenderWalletic } from "../../../../static/customer-ic-wallet.svg";
import { ReactComponent as SenderCashic } from "../../../../static/ic-cash.svg";
import { ReactComponent as ReceiverCashic } from "../../../../static/customer-ic-by-receiver.svg";
import customericbalancecard from "../../../../static/customer-ic-balance-card.svg";
import Dialog from "@material-ui/core/Dialog";
import { Api_Get_Payment_Methods_AGW, Api_New_Payment_Order_AGW } from "../../../../helper/api/ApiGateway";
import Wallet from "../../../Main/Menu/wallet";
import Stripe_Add_Card from "./changeMethod/stripe";
import PaymentIcon from "react-payment-icons-inline";


class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cards: [],
      showpoperMethod: false,
      showpoperSide: false,
      Inc_Balance: false,
      amountEntered: "",
      selectedGateWay: null,
      paymentSide: [
        {
          i18: "SenderWallet",
          data: {
            paymentSide: "Sender",
            paymentMethod: "Wallet",
            paymentProvider: null,
            cardInfo: null,
            paymentMethodId: null,
          },
        },
        {
          i18: "SenderCash",
          data: {
            paymentSide: "Sender",
            paymentMethod: "Cash",
            paymentProvider: null,
            cardInfo: null,
            paymentMethodId: null,
          },
        },
        {
          i18: "ReceiverCash",
          data: {
            paymentSide: "Receiver",
            paymentMethod: "Cash",
            paymentProvider: null,
            cardInfo: null,
            paymentMethodId: null,
          },
        },
      ],
    };
    this.paymentSide = React.createRef();
    this.getCards = this.getCards.bind(this)
    this.checkWalletDisable = this.checkWalletDisable.bind(this)
    this.getSenderWalletText = this.getSenderWalletText.bind(this)

  }


  getSenderWalletText = (i18) => {
    if(get_customerPannel_type() == "business" && this.props.isInvoiceActive){
      return this.props.t("account")
    }else{
      return this.props.t(i18)
    }
  };

  bussinessisInvoiceActive = () => {
    if(get_customerPannel_type() == "business" && this.props.isInvoiceActive){
      return true
    }else{
      return false
    }
  };


  getImageOfPaymentMeyhod = (name) => {
    if (name == "SenderWallet") {
      return <SenderWalletic className="dgieh c7921369" />
    } else if (name == "SenderCash") {
      return <SenderCashic className="dgieh w9647" />
    } else if (name == "ReceiverCash") {
      return <ReceiverCashic className="dgieh wr98364" />
    }
  }

  handleshowpoperPaymentSide = (bool) => {
    this.setState({
      showpoperSide: bool,
    });
  };

  handleAmountEntered = (e, number) => {
    this.setState({
      amountEntered: number ? number : e.target.value,
    });
  }

  handleShowIncBalance = (bool) => {
    this.setState({
      Inc_Balance: bool,
      amountEntered: "",
    });
  };

  handleSelectedItem = (item) => {
    this.props.dispatch(New_Travel_PaymentMethod(item.data));
    this.setState({
      showpoperSide: false,
      showpoperMethod: false,
    });
  };

  handleSelectedItemStripe = (item) => {
    this.props.dispatch(New_Travel_PaymentMethod({
      paymentSide: "Sender",
      paymentMethod: "Card",
      paymentProvider: "stripe",
      cardInfo: item,
      paymentMethodId: item.id,

    }));
    this.setState({
      showpoperSide: false,
      showpoperMethod: false,
    });
  };


  getCards() {
    Api_Get_Payment_Methods_AGW(this.props.dispatch, this.setCards)
  }


  setCards = (cards) => {
    this.setState({
      cards
    })
  }



  checkWalletDisable = () => {

    if(this.props.price.done){
      if (Number(this.props.balance) >= Number(this.props.price.price.price) || ((this.props.balance - this.props.price.price.price + this.props.price.price.promoAmount) >= this.props.minimumBalance)) {
        return false
      } else {
        return true
      }
    }else {
      return true
    }
    
  }



  WalletCheck = (item) => {
    if (
      (item
        ? item.paymentSide + item.paymentMethod
        : this.props.paymentSide + this.props.paymentMethod) == "SenderWallet"
    ) {
      if (this.props.price.done && this.props.price.price.price )  {
        if (this.WalletBalance(this.props, item)) {
          return "green";
        } else {
          return "red";
        }
      } else {
        return "grey";
      }
    } else {
      return "grey";
    }
  };

  WalletBalance = (props, item) => {
      if (
        (item
          ? item.paymentSide + item.paymentMethod
          : props.paymentSide + props.paymentMethod) == "SenderWallet"
      ) {
        if ( (props.balance - props.price.price.price + props.price.price.promoAmount) >= props.minimumBalance) {
          return true
        } else {
          return Number(props.price.price.price - props.price.price.promoAmount) <=
            Number(props.balance)
        }
      } else {
        return Number(props.price.price.price - props.price.price.promoAmount) <=
          Number(props.balance)
      }
 
  };


  hanlePay = () => {
    if (this.state.amountEntered.length > 0) {
      this.saveReducerInLocalStorage()
      Api_New_Payment_Order_AGW(this.props.dispatch, this.removeEmpty({
        "customerId": get_Id(),
        "amount": this.state.amountEntered,
        "deviceType": "web",
        "packageName": null,
        "gateway": this.state.selectedGateWay || this.props.payment[0].gateway
      })
      )
    }
  }

  neededBalance = () => {
    return (Number(
      this.props.price.price.price - this.props.price.price.promoAmount
    ) - Number(this.props.balance))
  }

  removeEmpty = (obj) => {
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
  }

  saveReducerInLocalStorage = () => {
    let data = {
      driver: {
        auto_activeVehicleType: this.props.auto_activeVehicleType,
        options: this.props.driver_options
      },
      dropOffs: {
        firstDropOff: this.props.NRdropOffAddress,
        otherDropOffs: this.props.NRotherDropOffs
      },
      service: {
        activeVehicleType: this.props.active_service,
        options: this.props.service_options
      },
      pickup: this.props.NRpickupAddress,
    }
    localStorage.setItem("draft", JSON.stringify(data));
  }



  componentDidMount() {


    if (this.props.price.price && ((this.props.balance - this.props.price.price.price + this.props.price.price.promoAmount) >= this.props.minimumBalance)) {
      this.props.dispatch(New_Travel_PaymentMethod({
        paymentSide: "Sender",
        paymentMethod: "Wallet",
        paymentProvider: null,
        cardInfo: null,
        paymentMethodId: null,
      }));
    }else if(this.props.price.price &&  ((this.props.balance - this.props.price.price.price + this.props.price.price.promoAmount) < this.props.minimumBalance)){
      if (this.props.serviceSettings.isCashBySenderActive) {
        //sender cash
        this.props.dispatch(New_Travel_PaymentMethod({
          paymentSide: "Sender",
          paymentMethod: "Cash",
          paymentProvider: null,
          cardInfo: null,
          paymentMethodId: null,
          where: "263"
        }));

      } else if (this.props.serviceSettings.enableReceiverCash) {
        //Receiver cash
        this.props.dispatch(New_Travel_PaymentMethod({
          paymentSide: "Receiver",
          paymentMethod: "Cash",
          paymentProvider: null,
          cardInfo: null,
          paymentMethodId: null,
        }));
      }
    }


 

    if ((global.config.stripePublicApiKey && global.config.stripePublicApiKey.length > 0) && get_Id() && this.state.cards.length == 0) {
      Api_Get_Payment_Methods_AGW(this.props.dispatch, this.setCards)
    }

  }


  componentWillReceiveProps(nextProps) {



try {
      if(nextProps.paymentMethod == null ) {
        if (nextProps.price.price && (nextProps.balance - nextProps.price.price.price + nextProps.price.price.promoAmount) >= nextProps.minimumBalance) {
          nextProps.dispatch(New_Travel_PaymentMethod({
            paymentSide: "Sender",
            paymentMethod: "Wallet",
            paymentProvider: null,
            cardInfo: null,
            paymentMethodId: null,
          }));
        }else if(nextProps.price.price && (nextProps.balance - nextProps.price.price.price + nextProps.price.price.promoAmount) < nextProps.minimumBalance){
          if (nextProps.serviceSettings.isCashBySenderActive) {
            //sender cash
            nextProps.dispatch(New_Travel_PaymentMethod({
              paymentSide: "Sender",
              paymentMethod: "Cash",
              paymentProvider: null,
              cardInfo: null,
              paymentMethodId: null,
              where: "341"
            }));
    
          } else if (nextProps.serviceSettings.enableReceiverCash) {
            //sender cash
            nextProps.dispatch(New_Travel_PaymentMethod({
              paymentSide: "Receiver",
              paymentMethod: "Cash",
              paymentProvider: null,
              cardInfo: null,
              paymentMethodId: null,
            }));
          }
        }
  
    
      }
} catch (error) {
  
}

    // if(nextProps.OpenDialoge && !this.props.OpenDialoge){
    //   if (get_customerPannel_type() == "business") {
    //     if (Get_Permisssion().canWalletBeNegative) {
    //       nextProps.dispatch(New_Travel_PaymentMethod({
    //         paymentSide: "Sender",
    //         paymentMethod: "Wallet",
    //         paymentProvider: null,
    //         cardInfo: null,
    //         paymentMethodId: null,
    //       }));
    //     } else {
    //       if (nextProps.serviceSettings.isCashBySenderActive) {
    //         //sender cash
    //         nextProps.dispatch(New_Travel_PaymentMethod({
    //           paymentSide: "Sender",
    //           paymentMethod: "Cash",
    //           paymentProvider: null,
    //           cardInfo: null,
    //           paymentMethodId: null,
    //           where: "257"
    //         }));
  
    //       } else if (nextProps.serviceSettings.enableReceiverCash) {
    //         //sender cash
    //         nextProps.dispatch(New_Travel_PaymentMethod({
    //           paymentSide: "Receiver",
    //           paymentMethod: "Cash",
    //           paymentProvider: null,
    //           cardInfo: null,
    //           paymentMethodId: null,
    //         }));
    //       }
    //     }
  
    //   }else {
    //     if (nextProps.serviceSettings.isCashBySenderActive) {
    //       //sender cash
    //       nextProps.dispatch(New_Travel_PaymentMethod({
    //         paymentSide: "Sender",
    //         paymentMethod: "Cash",
    //         paymentProvider: null,
    //         cardInfo: null,
    //         paymentMethodId: null,
    //         where: "257"
    //       }));
  
    //     } else if (nextProps.serviceSettings.enableReceiverCash) {
    //       //sender cash
    //       nextProps.dispatch(New_Travel_PaymentMethod({
    //         paymentSide: "Receiver",
    //         paymentMethod: "Cash",
    //         paymentProvider: null,
    //         cardInfo: null,
    //         paymentMethodId: null,
    //       }));
    //     }
    //   }
  
    // }

    // if ("SenderWallet" == this.props.paymentSide + this.props.paymentMethod && get_customerPannel_type() == "business" && 
    //  !Get_Permisssion().canWalletBeNegative &&  Number(nextProps.balance) <= 0 ) {

    //   if (this.props.serviceSettings.isCashBySenderActive) {
    //     //sender cash
    //     this.props.dispatch(New_Travel_PaymentMethod({
    //       paymentSide: "Sender",
    //       paymentMethod: "Cash",
    //       paymentProvider: null,
    //       cardInfo: null,
    //       paymentMethodId: null,
    //       where:"257"
    //     }));

    //   } else if (this.props.serviceSettings.enableReceiverCash) {
    //     //sender cash
    //     this.props.dispatch(New_Travel_PaymentMethod({
    //       paymentSide: "Receiver",
    //       paymentMethod: "Cash",
    //       paymentProvider: null,
    //       cardInfo: null,
    //       paymentMethodId: null,
    //     }));
    //   }
    // }else if(get_customerPannel_type() != "business" && "SenderWallet" == this.props.paymentSide + this.props.paymentMethod && ["grey" , "red"].indexOf(this.WalletCheck() ) > -1 ){
    //   if (this.props.serviceSettings.isCashBySenderActive) {
    //     //sender cash


    //     this.props.dispatch(New_Travel_PaymentMethod({
    //       paymentSide: "Sender",
    //       paymentMethod: "Cash",
    //       paymentProvider: null,
    //       cardInfo: null,
    //       paymentMethodId: null,
    //       where:"257"
    //     }));



    //   } else if (this.props.serviceSettings.enableReceiverCash) {
    //     //sender cash
    //     this.props.dispatch(New_Travel_PaymentMethod({
    //       paymentSide: "Receiver",
    //       paymentMethod: "Cash",
    //       paymentProvider: null,
    //       cardInfo: null,
    //       paymentMethodId: null,
    //     }));

    //   }
    // }


    if ((global.config.stripePublicApiKey && global.config.stripePublicApiKey.length > 0) && get_Id() && this.state.cards.length == 0) {
      Api_Get_Payment_Methods_AGW(this.props.dispatch, this.setCards)
    }


  }


  render() {
    const { t } = this.props;

    console.log("13543799623 , ", this.state)
    return (
      <React.Fragment>


        <paymentMethodContainerNewOrder onClick={() => this.handleshowpoperPaymentSide(true)} ref={this.paymentSide}
          id={this.props.id}
        >

          <div className="opdrtmff">
            {"SenderCard" == this.props.paymentSide + this.props.paymentMethod ? (
              <PaymentIcon
              icon={this.props.cardInfo.brand}
                className="dgieh"
              />
            ) : (
              this.getImageOfPaymentMeyhod(this.props.paymentSide + this.props.paymentMethod)
            )}

            <span className="pfkwuhh"> {"SenderCard" == this.props.paymentSide + this.props.paymentMethod ? `**** ${this.props.cardInfo.lastNumbers}` : (this.props.paymentSide ? <Trans i18nKey={(this.props.paymentSide + this.props.paymentMethod == "SenderWallet" ? this.getSenderWalletText("SenderWallet")  : this.props.paymentSide + this.props.paymentMethod  )}></Trans> : <Trans i18nKey="PleaseSelect"></Trans>)} </span>
            <img className={`fowiaaroow ${this.state.showpoperSide && "rotate180"}`} src={arrow} />

          </div>

          <key>
            <Trans i18nKey={"paymentmethod"}> </Trans>
          </key>

        </paymentMethodContainerNewOrder>


        {/* <clickableservice
          className={`clickableChangeMethod marginR10  ${
            this.WalletCheck() == "green"
              ? "SenderWallet"
              : this.WalletCheck() == "red"
              ? "SenderWalletred"
              : ""
          }  ${this.WalletCheck() == "red" ? "clickableserviceRed" : ""}
          `}
          style={{
            marginRight: "0px",
          }}
          ref={this.paymentSide}
          id={this.props.id}
          onClick={() => this.handleshowpoperPaymentSide(true)}
        >
          {
            <img
              src={arrow}
              className={`${this.state.showpoperSide && "rotate180"} ${
                this.WalletCheck() == "red" ? "mrt10" : ""
              }`}
            />
          }
          <span
            className={`paymentmethodspan ${this.props.paymentSide + this.props.paymentMethod} ${
              this.props.paymentSide + this.props.paymentMethod !=
              "SenderWallet"
                ? "paymentmethodspanoedited"
                : this.WalletCheck() != "red"
                ? "paymentmethodspanoedited"
                : ""
            }`}
          >
            {" "}
            <Trans i18nKey={this.props.paymentSide + this.props.paymentMethod}>
              {" "}
            </Trans>
          </span>
          {this.props.paymentSide + this.props.paymentMethod ==
          "SenderWallet" ? (
            this.WalletCheck() == "red" ? (
              <span className="lowBalance">
                {" "}
                <Trans i18nKey={"lowBalance"}></Trans>
              </span>
            ) : null
          ) : null}
        </clickableservice> */}

        <Popper
          open={this.state.showpoperSide}
          anchorEl={this.paymentSide.current}
          role={undefined}
          placement={"bottom"}
          style={{
            zIndex: 7,
            marginTop: "4px",
            border: "solid 1px rgba(128, 128, 128, 0.2)",
            borderRadius: "8px",
            boxShadow: "0 2px 8px 0 rgba(128, 128, 128, 0.24)",
          }}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              timeout={{ enter: 150, exit: 150 }}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper className="paymentMethodsPopper">
                <ClickAwayListener
                  onClickAway={() => this.handleshowpoperPaymentSide(false)}
                >
                  <div>

                  {  !this.bussinessisInvoiceActive() &&
                    <div className="BalanceContainer">
                      <Balance className="balanceicon" />
                      <Plus className="increaseBalance"
                        onClick={() => this.handleShowIncBalance(true)} />
                      {/* <img
                        className="increaseBalance"
                        src={plus}
                        onClick={() => this.handleShowIncBalance(true)}
                      /> */}
                      <span className="BalanceText">
                        {" "}
                        <Trans i18nKey={"Balance"}> </Trans>
                      </span>
                      <span className="BalanceNumberText">
                        {" "}
                        {this.props.balancecurrencyCode
                          ? Number(this.props.balance).toLocaleString(
                            get_lang(),
                            {
                              style: "currency",
                              currency: this.props.balancecurrencyCode,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )
                          : this.props.balance}
                      </span>
                    </div>}

                    <span className="Methods" style={{marginTop:this.bussinessisInvoiceActive() && "0"}}>
                      {" "}
                      <Trans i18nKey={"Methods"}> </Trans>{" "}
                    </span>

                    <div
                      className={`MethodsItem ${this.checkWalletDisable() ? "paymentMethodDisable" :
                        this.state.paymentSide[0].i18 ==
                          this.props.paymentSide + this.props.paymentMethod
                          ? "MethodsItemActive"
                          : ""
                        } 
                      
                      ${this.WalletCheck() == "red" && "redborder"}`}
                      onClick={() =>
                        !this.checkWalletDisable() && this.handleSelectedItem(this.state.paymentSide[0])
                      }
                    >
                      <SenderWalletic className="img c7921369" />
                      <span>
                        {" "}
                        {this.getSenderWalletText("SenderWallet")}
                      </span>
                    </div>

                    {this.WalletCheck() == "red" ? (
                      <span className="balanceError">
                        {" "}
                        <Trans i18nKey={"balanceError"}> </Trans>{" "}
                      </span>
                    ) : null}

                    {this.props.serviceSettings.isCashBySenderActive && (
                      <div
                        className={`MethodsItem ${this.state.paymentSide[1].i18 ==
                            this.props.paymentSide + this.props.paymentMethod
                            ? "MethodsItemActive"
                            : ""
                          }`}
                        onClick={() =>
                          this.handleSelectedItem(this.state.paymentSide[1])
                        }
                      >
                        <SenderCashic className="img w9647" />
                        <span>
                          {" "}
                          <Trans i18nKey={"SenderCash"}> </Trans>{" "}
                        </span>
                      </div>
                    )}

                    {this.props.serviceSettings.enableReceiverCash && (
                      <div
                        className={`MethodsItem ${this.state.paymentSide[2].i18 ==
                            this.props.paymentSide + this.props.paymentMethod
                            ? "MethodsItemActive"
                            : ""
                          }`}
                        onClick={() =>
                          this.handleSelectedItem(this.state.paymentSide[2])
                        }
                      >
                        <ReceiverCashic className="img wr98364" />
                        <span>
                          {" "}
                          <Trans i18nKey={"ReceiverCash"}> </Trans>{" "}
                        </span>
                      </div>
                    )}

                    {this.state.cards.map((card) => {
                      return <div
                        className={`MethodsItem ${("SenderCard" ==
                          this.props.paymentSide + this.props.paymentMethod
                        ) && this.props.paymentMethodId == card.id ? "MethodsItemActive"
                          : ""
                          }`}
                          style={{display:"flex",flexDirection:"row" ,justifyContent:"start",alignItems:"center"}}
                        onClick={() =>
                          this.handleSelectedItemStripe(card)
                        }

                      >
                        <PaymentIcon
                          icon={card.brand}
                          style={{ height: '16px' }}
                        />
                        <span>
                          {`**** ${card.lastNumbers}`}
                        </span>
                      </div>
                    })}

                    {global.config.stripePublicApiKey && <Stripe_Add_Card onClose={this.getCards} />}


                    {/* <MenuList
                    autoFocusItem={this.state.activestop}
                    id="menu-list-grow"
                    onKeyDown={(e) => {
                      this.handleListKeyDownTime(e);
                    }}
                  >
                    {this.state.paymentSide.map((method) => {
                      return (
                        <MenuItem
                          className="serviceListOption"
                          onClick={() => this.handleSelectedItem(method)}
                        >
                          <Trans i18nKey={method.i18}> </Trans>
                        </MenuItem>
                      );
                    })}
                  </MenuList> */}
                  </div>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>


        <Wallet ShowComponent={false} OpenDialoge={this.state.Inc_Balance} prefered={this.WalletCheck() == "red" ? this.neededBalance() : 0} onClose={() => this.handleShowIncBalance(false)} />

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  OpenDialoge: state.NewOrder.OpenDialoge,

  price: state.NewOrder.newOrder.price,
  paymentMethod: state.NewOrder.newOrder.paymentMethod.paymentMethod,
  paymentSide: state.NewOrder.newOrder.paymentMethod.paymentSide,
  balance: state.NewOrder.newOrder.balance.balance,
  balancecurrencyCode: state.NewOrder.newOrder.balance.currencyCode,
  serviceSettings: state.NewOrder.newOrder.service.activeVehicleType
    ? state.NewOrder.newOrder.service.activeVehicleType.setting
    : { enableReceiverCash: false, isCashBySenderActive: false },

  defaultsAmount: state.SharedData.WebSettings ? state.SharedData.WebSettings.predefinedPaymentValues : null,
  currencyCode: state.SharedData.WebSettings ? state.SharedData.WebSettings.currencyCode : null,
  payment: state.SharedData.WebSettings ? state.SharedData.WebSettings.payment || [] : [],
  isInvoiceActive: state.SharedData.WebSettings ? state.SharedData.WebSettings.isInvoiceActive : null,


  cardInfo: state.NewOrder.newOrder.paymentMethod.cardInfo,
  paymentMethodId: state.NewOrder.newOrder.paymentMethod.paymentMethodId,

  active_service: state.NewOrder.newOrder.service.activeVehicleType,
  service_options: state.NewOrder.newOrder.service.options,
  auto_activeVehicleType:
    state.NewOrder.newOrder.driver.auto_driver.auto_activeVehicleType,
  driver_options: state.NewOrder.newOrder.driver.options,
  NRdropOffAddress: state.NewOrder.newOrder.dropOffs.firstDropOff,
  NRotherDropOffs: state.NewOrder.newOrder.dropOffs.otherDropOffs,
  NRpickupAddress: state.NewOrder.newOrder.pickup,
  minimumBalance:state.NewOrder.newOrder.balance.minimumBalance,

});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
